import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45123219")

_pushScopeId("data-v-45123219")
const _hoisted_1 = { class: "text-gray-lp-300 font-semibold text-xl text-center" }
const _hoisted_2 = { class: "text-gray-lp-300" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col mt-2"
}
const _hoisted_5 = { class: "items-center mx-auto flex flex-row rounded-b-md text-xs gap-x-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalProses = _resolveComponent("ModalProses")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock(_component_ModalProses, {
        key: 0,
        isCustomTitle: "",
        width: "instant-booking-popup",
        onClose: _ctx.onCloseModal,
        footerBgColor: '',
        boxShadow: 'none',
        isRounded: true,
        showClosed: false,
        showBorderTitle: false,
        titlePadding: 'px-8 pt-4 pb-0',
        contentPadding: 'px-8 pt-4 pb-0',
        minHeight: _ctx.isStatus === 'OUT-HUB' ? '12rem' : ''
      }, {
        "custom-title": _withId(() => [
          _createVNode("h4", _hoisted_1, _toDisplayString(_ctx.$t('hubToHub.confirmProcessManifest')), 1)
        ]),
        content: _withId(() => [
          _createVNode("section", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_DataWrapper, {
                label: "Plat nomor",
                class: "w-full"
              }, {
                default: _withId(() => [
                  _createVNode(_component_LpInput, {
                    placeholder: _ctx.$t('hubToHub.plateNumberPlaceholder'),
                    modelValue: _ctx.vehiclePlate,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => (_ctx.vehiclePlate = $event)),
                      _ctx.validateVehicleNumber
                    ],
                    error: _ctx.error.vehiclePlate,
                    errorCaption: _ctx.errorCaption.vehiclePlate,
                    format: _ctx.formatPlateNumber
                  }, null, 8, ["placeholder", "modelValue", "error", "errorCaption", "format", "onUpdate:modelValue"])
                ]),
                _: 1
              })
            ]),
            (_ctx.isStatus == 'OUT-HUB')
              ? (_openBlock(), _createBlock("div", _hoisted_4, [
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('hubToHub.destinationHub'),
                    class: "w-full"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_SelectSearchV2, {
                        onFilter: _cache[2] || (_cache[2] = (search) => _ctx.filterHubLists(search)),
                        options: _ctx.filterHubList,
                        keyName: "hubName",
                        keyValue: "hubId",
                        placeholder: _ctx.$t('hubToHub.destinationHub'),
                        modelValue: _ctx.hub,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.hub = $event)),
                        onChange: _ctx.onSelectHub,
                        isDisabled: _ctx.hubList.length <= 1,
                        class: "my-2"
                      }, null, 8, ["options", "placeholder", "modelValue", "onChange", "isDisabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        footer: _withId(() => [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_LpButton, {
              isWidthFull: "",
              title: _ctx.$t('hubToHub.back'),
              outline: "",
              textColor: "red-lp-100",
              color: "red-lp-100",
              customClass: "py-3",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onCloseModal()))
            }, null, 8, ["title"]),
            _createVNode(_component_LpButton, {
              disabled: !_ctx.vehiclePlate || _ctx.error.vehiclePlate,
              isWidthFull: "",
              title: _ctx.$t('hubToHub.process'),
              textColor: "white",
              color: "red-lp-100",
              customClass: "py-3",
              onClick: _ctx.onConfirm
            }, null, 8, ["disabled", "title", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["onClose", "minHeight"]))
    : _createCommentVNode("", true)
})